import React from "react";

function QueryTextInput({ value, onChange }) {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };

  return (
    <div className="mb-3">
      <label htmlFor="queryTextArea" className="form-label">
        Query
      </label>
      <textarea
        className="form-control"
        id="queryTextArea"
        onChange={handleChange}
        placeholder="Enter any relevant text -- the more the better!"
        rows="8"
        value={value}
      />
    </div>
  );
}

export default QueryTextInput;
